(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["baetter-add-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('cart:update',function(e){
  var d=e.detail&&e.detail.data;
  if(!d||d.source!=='product-form-component'||d.didError)return;
  var t=e.target;
  if(!t||!t.closest||!t.closest('[data-bt-atc]'))return;
  var drawer=document.querySelector('cart-drawer-component');
  if(drawer&&!drawer.hasAttribute('auto-open')&&typeof drawer.open==='function')drawer.open();
});
  } catch(e) { console.error(e); }
})();

})();
